{
  "header": {
    "title": "Profile",
    "description": "Manage your user account"
  },
  "tabs": {
    "settings": {
      "label": "Settings",
      "saveChangeButton": "Save changes",
      "photoSection": {
        "title": "Photo",
        "changePhotoButton": "Change photo",
        "maxSize": "Max. 5MB",
        "format": "PNG, JPG format"
      },
      "personalInformationSection": {
        "title": "Personal Information",

        "nonEditable": {
          "nameInput": { "label": "Name" },
          "jobTitleInput": { "label": "Job Title" },
          "managerNameInput": { "label": "Manager’s name" },
          "userRoleInput": { "label": "User role" },
          "emailInput": { "label": "Email" },
          "departmentInput": { "label": "Department" },
          "tenureInput": { "label": "Tenure" }
        },

        "editable": {
          "languageInput": { "label": "Language" },
          "dateFormatInput": { "label": "Date format" },
          "locationInput": { "label": "Location" },
          "timeZoneInput": { "label": "Time Zone" }
        }
      },
      "emailPreferencesSection": {
        "weeklyDigest": "Send a weekly digest email of recent questions",
        "monthlyDigest": "Send a monthly digest email with your insights"
      }
    },
    "directReports": {
      "label": "My direct reports",
      "emptyState": {
        "title": "No direct reports",
        "description": "You don’t have any direct reports assigned to you yet. When people report to you, they will appear here."
      },
      "error": {
        "title": "Couldn’t load direct reports",
        "description": "Something went wrong while loading your direct reports. Please try again.",
        "retry": "Try again"
      }
    }
  }
}
